// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__29j4Y","label":"Labeled_label__L7dKx","divider":"Labeled_divider__2Mv80"};